import React from "react";
import { Link } from "react-router-dom";
import logo from "../Utilities/Image/logo.png";
import auth from "../firebase.init";
import { useAuthState } from "react-firebase-hooks/auth";
import LoadingSpinner from "../Shared/LoadingSpinner";
import { BiMenu } from "react-icons/bi";
import { AiOutlineUser } from "react-icons/ai";

const Navbar = () => {
  const [user, loading] = useAuthState(auth);

  if (loading) {
    return <LoadingSpinner></LoadingSpinner>;
  }
  return (
    <div className="navbar  bg-indigo-500">
      <div className="navbar-start">
        <Link to="/">
          <img className="w-16" src={logo} alt="" />
        </Link>
      </div>
      <div className="navbar-center">
        <label htmlFor="my-drawer-2" className="btn lg:hidden">
          <BiMenu className="text-xl" />
        </label>
      </div>
      <div className="navbar-end">
        <p className="md:flex justify-center hidden items-center gap-1 px-4 border-2 border-white rounded-lg p-1 text-white">
          <AiOutlineUser />
          {user && user.email}
        </p>
      </div>
    </div>
  );
};

export default Navbar;
